import { Download } from "@mui/icons-material"
import { IconButton, IconButtonProps, Tooltip } from "@mui/material"

type DownloadbuttonProps = IconButtonProps & {
  // own props
}

const DownloadButton = (props: DownloadbuttonProps) => {
  return (
    <Tooltip title="Download">
      <IconButton color="primary" {...props}>
        <Download />
      </IconButton>
    </Tooltip>
  )
}

export default DownloadButton
